// Constants
import { PHONE_OPTIONS } from '@/core/constants/phone.constants'

// Types
import { PhoneOption } from '@/core/types/phone.types'

export const detectOptionByPhoneNumber = (phone_number: string): PhoneOption | undefined => {
    const code = phone_number.split('-')[1]
    const option = PHONE_OPTIONS.find(
        (option) =>
            code[0] === option.phone_code.toString()[0] &&
            code.includes(option.phone_code.toString())
    )

    return option
}
